import axios from './../api.js'
import Vue from 'vue'

const state = {
    applicationSettingsDrive: [],
    selectedView: null,
    organizationEmployeeList: null,
    associatedOrganizationList: [],
    allOrganizationList: [],
    selectedCompanies: [],
    associatedOrganizationEmployeeList: null,
    application: null,
    groupIdList: [],
    allCodeLists: [],
    userSelectLists: [],
    selectedUserSelectListItem: null,
    selectedUserSelectList: null,
    selectedBusinessAreaSystemName: null,
    selectedMultipleSupplyType: [],
    userExist: null,
    companyExist: null,
    employee: {
        username: null,
        name: null,
        password: null,
        email: null,
        phoneNumber: null,
        note: null,
        organizationId: null,
        userId: null
    },
    company: {
        address1: null,
        city: null,
        email: null,
        id: null,
        name: null,
        note: null,
        phoneNumber: null
    },

    associatedUserList: [],
    userFacilityGroups: [],
    facilityGroups: []
}

const getters = {
    getApplicationSettingsDrive: state => {
        return state.applicationSettingsDrive
    },
    getAdministrationView: state => {
        return state.selectedView
    },
    getOrganizationEmployeeList: state => {
        return state.organizationEmployeeList
    },
    getAssociatedOrganizationList: state => {
        return state.associatedOrganizationList
    },
    getAllOrganizationList: state => {
        return state.allOrganizationList
    },
    getSelectedCompanies: state => {
        return state.selectedCompanies
    },
    getApplication: state => {
        return state.application
    },
    getAllCodeLists: state => {
        return state.allCodeLists
    },
    getUserSelectLists: state => {
        return state.userSelectLists
    },
    getSelectedUserSelectListItem: state => {
        return state.selectedUserSelectListItem
    },
    getSelectedUserSelectList: state => {
        return state.selectedUserSelectList
    },
    getSysBusinessAreaTypeList: state => {
        return state.allCodeLists.sysBusinessAreaTypeList
    },
    getSelectedBusinessAreaSystemName: state => {
        return state.selectedBusinessAreaSystemName
    },
    getSelectedMultipleSupplyType: state => {
        return state.selectedMultipleSupplyType
    },
    getGroupIdList: state => {
        return state.groupIdList
    },
    getUserExist: state => {
        return state.userExist
    },
    getEmployee: state => {
        return state.employee
    },
    getCompanyExist: state => {
        return state.companyExist
    },
    getCompany: state => {
        return state.company
    },

    getAssociatedUsers: state => {
        return state.associatedUserList
    },
    getUserFacilityGroups: state => {
        return state.userFacilityGroups
    },
    getFacilityGroups: state => {
        return state.getFacilityGroups
    }
}

const mutations = {
    setApplicationSettingsDrive: (state, payload) => {
        state.applicationSettingsDrive = payload
    },
    setAdministrationView: (state, payload) => {
        state.selectedView = payload
    },
    setOrganizationEmployeeList: (state, payload) => {
        state.organizationEmployeeList = payload
    },
    setEmployeeUnlocked: (state, payload) => {
        let listIdx = state.organizationEmployeeList.findIndex(i => i.userId === payload)
        state.organizationEmployeeList[listIdx].lockedOut = false
    },
    setClearAssociatedOrganizationList: (state) => {
        state.associatedOrganizationList = []
    },
    setAssociatedOrganizationList: (state, payload) => {
        state.associatedOrganizationList = payload
    },
    setAllOrganizationList: (state, payload) => {
        let match = false
        state.allOrganizationList = payload
        state.associatedOrganizationList.forEach(assorgItem => {
            match = false
            state.allOrganizationList.forEach(allorgItem => {
                if (allorgItem.id === assorgItem.id) {
                    match = true
                }
            })
            if (match === false) {
                state.allOrganizationList.push(assorgItem)
            }
        })
    },
    setSelectedCompanies: (state, payload) => {
        state.selectedCompanies = []
        state.selectedCompanies.push(payload)
    },
    setSelectedCompaniesEmpty: (state) => {
        state.selectedCompanies = []
    },
    setCreateOrganization: (state, payload) => {
        let organizationMatch = false

        for (let i = 0; i < state.associatedOrganizationList.length; i++) {
            if (state.associatedOrganizationList[i].id === payload.id) {
                organizationMatch = true
                state.associatedOrganizationList[i] = payload
            }
        }
        if (!organizationMatch) {
            state.associatedOrganizationList.push(payload)
        }
    },
    setApplication: (state, payload) => {
        state.application = payload.applicationList.filter(app => app.key === payload.appId)[0]
    },
    setGroupIdList: (state, payload) => {
        state.groupIdList = []
        payload.forEach(response => {
            response.forEach(app => {
                state.groupIdList.push(app.key)
            })
        })
    },
    setAllCodeLists: (state, payload) => {
        state.allCodeLists = payload
    },
    setUserSelectLists: (state, payload) => {
        state.userSelectLists = payload
    },
    setSelectedUserSelectListItem: (state, payload) => {
        state.selectedUserSelectListItem = payload
    },
    setSelectedUserSelectList: (state, payload) => {
        state.selectedUserSelectList = payload
    },
    setSelectedBusinessAreaSystemName: (state, payload) => {
        state.selectedBusinessAreaSystemName = payload
    },
    setUpdateSelectList: (state, payload) => {
        let newItem = {
            'typeId': payload.typeId,
            'description': payload.description,
            'active': payload.active,
            'tagList': payload.tagList,
            'used': payload.used,
            'taskTemplateId': payload.taskTemplateId,
            'defaultOwnerUserId': payload.defaultOwnerUserId,
            'isPublic': payload.isPublic,
            'publicDescription': payload.publicDescription
        }

        if (payload.updateType === 'inserted') {
            newItem.used = false
            state.selectedUserSelectList.list.unshift(newItem)
        }

        if (payload.updateType === 'updated') {
            let updIdx = state.selectedUserSelectList.list.findIndex(i => i.typeId === payload.typeId)
            state.selectedUserSelectList.list.splice(updIdx, 1)
            state.selectedUserSelectList.list.unshift(newItem)
        }

        if (payload.updateType === 'deleted') {
            let delIdx = state.selectedUserSelectList.list.findIndex(i => i.typeId === payload.typeId)
            state.selectedUserSelectList.list.splice(delIdx, 1)
        }

        let listIdx = state.userSelectLists.findIndex(i => i[0].systemName === state.selectedUserSelectList.systemName)
        switch (payload.businessAreaSystemName) {
        case ('sewer'):
            state.userSelectLists[listIdx][1].sewer.codelist = state.selectedUserSelectList.list
            break
        case ('water'):
            state.userSelectLists[listIdx][1].water.codelist = state.selectedUserSelectList.list
            break
        case ('trash'):
            state.userSelectLists[listIdx][1].trash.codelist = state.selectedUserSelectList.list
            break
        case ('treatmentplant'):
            state.userSelectLists[listIdx][1].treatmentPlant.codelist = state.selectedUserSelectList.list
            break
        case ('administration'):
            state.userSelectLists[listIdx][1].administration.codelist = state.selectedUserSelectList.list
            break
        case ('streetlights'):
            state.userSelectLists[listIdx][1].streetLights.codelist = state.selectedUserSelectList.list
            break
        case ('greencare'):
            state.userSelectLists[listIdx][1].greenCare.codelist = state.selectedUserSelectList.list
            break
        }
    },
    setSelectedMultipleSupplyType: (state, payload) => {
        let found = false
        let filteredSuppplyType = state.allCodeLists.sysBusinessAreaTypeList.filter(supplyType => supplyType.sysBusinessAreaTypeId === payload)[0]
        if (filteredSuppplyType) {
            if (state.selectedMultipleSupplyType.length > 0) {
                state.selectedMultipleSupplyType.forEach((sup, index) => {
                    if (sup.code === filteredSuppplyType.code) {
                        found = true
                        state.selectedMultipleSupplyType.splice(index, 1)
                    }
                })
            }
            if (!found) {
                let supply = {
                    'id': filteredSuppplyType.sysBusinessAreaTypeId,
                    'code': filteredSuppplyType.code,
                    'description': filteredSuppplyType.description,
                    'systemName': filteredSuppplyType.systemName
                }
                state.selectedMultipleSupplyType.push(supply)
            }
        }
    },
    setNonSelectedMultipleSupplyType: (state) => {
        state.selectedMultipleSupplyType = []
    },
    setEmployee: (state, payload) => {
        if (payload) {
            const user = JSON.parse(JSON.stringify(payload))
            state.employee = user
        } else {
            // Reset user
            Object.keys(state.employee).forEach(key => {
                state.employee[key] = null
            })
            state.selectedMultipleSupplyType = []
        }
    },
    setCompany: (state, payload) => {
        if (payload) {
            const company = JSON.parse(JSON.stringify(payload))
            state.company = company
        } else {
            // Reset company
            Object.keys(state.company).forEach(key => {
                state.company[key] = null
            })
        }
    },
    setUserExist: (state, payload) => {
        state.userExist = payload
    },
    setClearUserExist: (state) => {
        state.userExist = null
    },
    setCompanyExist: (state, payload) => {
        state.companyExist = payload
    },
    setClearCompanyExist: (state) => {
        state.companyExist = null
    },

    setAssociatedUsers: (state, payload) => {
        state.associatedUserList = payload
        let listIdx = state.organizationEmployeeList.findIndex(i => i.userId === state.employee.userId)
        if (state.associatedUserList.length > 0) {
            state.organizationEmployeeList[listIdx].usersAreAssociated = true
        } else {
            state.organizationEmployeeList[listIdx].usersAreAssociated = false
        }
    },
    setUserFacilityGroups: (state, payload) => {
        state.userFacilityGroups = payload
    },
    setFacilityGroups: (state, payload) => {
        state.facilityGroups = payload
    }
}

const actions = {
    setAdministrationView: ({ commit }, administrationView) => {
        commit('setAdministrationView', administrationView)
    },
    resetPassword: ({commit}, passwords) => {
        let passWObj = {
            newPassword: passwords.newPassword,
            oldPassword: passwords.oldPassword
        }
        return axios.post('Account/ResetPassword', passWObj).then((response) => {
            commit('successHandler')
        }, error => {
            commit('errorHandler', error)
        })
    },
    setApplicationSettingsDrive: ({ commit }) => {
        return axios.post('/Drive/GetApplicationSettings').then((response) => {
            commit('setApplicationSettingsDrive', response.data)
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    updateDriveSettings: ({ commit }, applicationSettingObject) => {
        return axios.post('/Drive/UpdateApplicationSettings', applicationSettingObject).then((response) => {
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    setOrganizationEmployeeList: ({ commit, rootState }, companyId) => {
        let q = {
            organizationUsersId: companyId,
            selectedOrganizationId: rootState.global.selectedOrganization.id,
            applicationId: state.application.key
        }
        return axios.post('/' + state.application.value + '/GetAssociatedOrganizationAllUserList', q).then((response) => {
            commit('setOrganizationEmployeeList', response.data)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setClearAssociatedOrganizationList: ({ commit }) => {
        commit('setClearAssociatedOrganizationList')
        return true
    },
    setAssociatedOrganizationList: ({ commit, rootState }) => {
        let appName

        // Again its only in drive right now we want these companies
        if (!state.application) {
            if (rootState.global.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
                appName = rootState.global.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].value
            }
        }
        return axios.post('/UserAdmin/GetAssociatedOrganizationList', {applicationName: appName}).then((response) => {
            commit('setAssociatedOrganizationList', response.data)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setAllOrganizationList: ({ commit, rootState }) => {
        let appName

        // Again its only in drive right now we want these companies
        if (!state.application) {
            if (rootState.global.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
                appName = rootState.global.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].value
            }
        }
        return axios.post('/UserAdmin/GetNotAssociatedOrganizationList', {applicationName: appName}).then((response) => {
            commit('setAllOrganizationList', response.data)
            return response
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setSelectedCompanies: ({ commit, dispatch }, company) => {
        commit('setSelectedCompanies', company)
        dispatch('setOrganizationEmployeeList', company.id)
    },
    setSelectedCompaniesEmpty: ({ commit }) => {
        commit('setSelectedCompaniesEmpty')
    },
    setCreateOrganization: ({ commit, dispatch }, company) => {
        let companyObj = {
            organizationId: company.id,
            name: company.name,
            note: company.note,
            address1: company.address1,
            city: company.city,
            postalCode: company.postalCode,
            email: company.email,
            phoneNumber: company.phoneNumber
        }
        return axios.post('/UserAdmin/CreateUpdateOrganization', companyObj).then((response) => {
            commit('setCreateOrganization', response.data)
            return response
        }, (response) => {
            let errorText = ''
            switch (response.response.data.ErrorCode) {
            case 1:
                errorText = 'En virksomhed med samme navn er allerede oprettet. Brug et andet navn'
                break
            case 2:
                errorText = 'En virksomhed med samme e-mail er allerede oprettet. Brug en anden e-mail'
                break
            case 3:
                errorText = 'En virksomhed med samme telefonnummer er allerede oprettet. Brug et andet telefonnummer'
                break
            default:
                errorText = 'Noget gik galt. Prøv venligst igen'
                break
            }
            Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
            commit('errorHandler', response)
            throw new Error(response)
        }).then((response) => {
            commit('setSelectedCompanies', response.data)
            dispatch('setOrganizationEmployeeList', response.data.id)
            dispatch('setAllOrganizationList')
            return response
        }).catch((error) => {
            return error
        })
    },
    setCreateUser: ({ commit, dispatch }, user) => {
        let userObj = {
            username: user.info.username,
            name: user.info.name,
            email: user.info.email,
            phone: user.info.phoneNumber,
            note: user.info.note,
            organizationId: user.info.organizationId
        }
        return axios.post('/UserAdmin/CreateUser', userObj).then((response) => {
            user.info.userId = response.data.userId
            return response.data
        }, (response) => {
            commit('errorHandler', response)
            throw new Error(response)
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setAddUserToOrganization', user))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setApplicationGroupList', user))
            })
        }).then(() => {
            if (user.active !== null) {
                if (user.active) {
                    return new Promise((resolve, reject) => {
                        resolve(dispatch('setActivateUser', user))
                    })
                } else {
                    return new Promise((resolve, reject) => {
                        resolve(dispatch('setDeactivateUser', user))
                    })
                }
            }
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setAddUserToUsergroup', user))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setOrganizationEmployeeList', state.selectedCompanies[0].id))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setAssociatedOrganizationList'))
            })
        }).catch((error) => {
            return error
        })
    },
    setUpdateUser: ({ commit, dispatch }, user) => {
        let userObj = {
            userId: user.info.userId,
            name: user.info.name,
            email: user.info.email,
            phoneNumber: user.info.phoneNumber
        }
        return axios.post('/UserAdmin/UpdateUserInfoAdmin', userObj).then((response) => {
            return response.data
        }, (response) => {
            if (response.response.data.ErrorCode !== 5) {
                commit('errorHandler', response)
                throw new Error(response)
            }
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setAddUserToOrganization', user))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setApplicationGroupList', user))
            })
        }).then(() => {
            if (user.active !== null) {
                if (user.active) {
                    return new Promise((resolve, reject) => {
                        resolve(dispatch('setActivateUser', user))
                    })
                } else {
                    return new Promise((resolve, reject) => {
                        resolve(dispatch('setDeactivateUser', user))
                    })
                }
            }
        }).then(() => {
            if (user.rolesToRemove && user.rolesToRemove.length > 0) {
                return new Promise((resolve, reject) => {
                    resolve(dispatch('setRemoveUserToUsergroup', user))
                })
            }
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setAddUserToUsergroup', user))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setOrganizationEmployeeList', state.selectedCompanies[0].id))
            })
        }).then(() => {
            return new Promise((resolve, reject) => {
                resolve(dispatch('setAssociatedOrganizationList'))
            })
        }).catch((error) => {
            return error
        })
    },
    removeUserFromFacilityUserGroup: ({ commit, dispatch }, params) => {
        return axios.post('/Facility/RemoveUserFromFacilityUserGroup', params).then((response) => {
            return new Promise((resolve, reject) => {
                resolve(response.data)
            })
        }, (response) => {
            if (response.response.data.ErrorCode !== 5) {
                commit('errorHandler', response)
                throw new Error(response)
            }
        })
    },
    addUserToFacilityUserGroup: ({ commit, dispatch }, params) => {
        return axios.post('/Facility/AddUserToFacilityUserGroup', params).then((response) => {
            return response.data
        }, (response) => {
            if (response.response.data.ErrorCode !== 5) {
                commit('errorHandler', response)
                throw new Error(response)
            }
        })
    },
    setAddUserToOrganization: ({ commit, rootState }, user) => {
        let userObj = {
            userId: user.info.userId,
            organizationId: rootState.global.selectedOrganization.id,
            tagList: user.tagList,
            permissionEditGisData: user.permissionEditGisData,
            automaticCloseTask: user.automaticCloseTask
        }
        return axios.post('/UserAdmin/AddUserToOrganization', userObj).then((response) => {
            return response.data
        }, (response) => {
            commit('errorHandler', response)
        })
    },
    setAddUserToUsergroup: ({ commit, rootState }, user) => {
        let userGroupObj = {
            userId: user.info.userId,
            organizationId: rootState.global.selectedOrganization.id,
            groupIdList: state.groupIdList
        }
        return axios.post('/UserAdmin/AddUserToUsergroup', userGroupObj).then((response) => {
            return response.data
        }, (response) => {
            commit('errorHandler', response)
            return response.data
        })
    },
    setRemoveUserToUsergroup: ({ commit, rootState }, user) => {
        let userGroupObj = {
            userId: user.info.userId,
            organizationId: rootState.global.selectedOrganization.id,
            groupIdList: user.rolesToRemove
        }
        return axios.post('/UserAdmin/RemoveUserFromUsergroup', userGroupObj).then((response) => {
            return response.data
        }, (response) => {
            commit('errorHandler', response)
            return response.data
        })
    },
    setApplication: ({ commit, rootState }, appId) => {
        commit('setApplication', {appId: appId, applicationList: rootState.global.applicationList})
    },
    setAllCodeLists: ({ commit }) => {
        return axios.post('/' + state.application.value + '/GetAllCodeLists', {getInactive: true}).then((response) => {
            commit('setAllCodeLists', response.data)
            if (state.userSelectLists === undefined || state.userSelectLists.length === 0) {
                let slist = [[{listName: 'Aktivitetstyper', systemName: 'activitytype'}, state.allCodeLists.cActivityTypeList],
                    [{listName: 'Kontakttyper', systemName: 'clienttype'}, state.allCodeLists.cClientTypeList],
                    [{listName: 'Ejendomstyper', systemName: 'estatetype'}, state.allCodeLists.cEstateTypeList],
                    [{listName: 'Problemtyper', systemName: 'problemtype'}, state.allCodeLists.cProblemTypeList],
                    [{listName: 'Vejrtyper', systemName: 'weathertype'}, state.allCodeLists.cWeatherTypeList]]
                commit('setUserSelectLists', slist)
            }
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    setSelectedUserSelectListItem: ({ commit }, selectedUserSelectListItem) => {
        commit('setSelectedUserSelectListItem', selectedUserSelectListItem)
        return true
    },
    setSelectedUserSelectList: ({ commit }, selectedUserSelectList) => {
        commit('setSelectedUserSelectList', selectedUserSelectList)
        return true
    },
    setSelectedBusinessAreaSystemName: ({ commit }, selectedBusinessAreaSystemName) => {
        commit('setSelectedBusinessAreaSystemName', selectedBusinessAreaSystemName)
        return true
    },
    createUpdateActivityType: ({ commit }, item) => {
        return axios.post('/Drive/CreateUpdateActivityType', item)
            .then((response) => {
                commit('setUpdateSelectList', response.data)
                return response
            }, (response) => {
                let errorText = ''
                switch (response.response.data.ErrorCode) {
                case 103:
                    errorText = 'Emnet eksisterer allerede i listen'
                    break
                default:
                    errorText = 'Noget gik galt. Prøv venligst igen'
                    break
                }
                Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
                commit('errorHandler', response)
                throw new Error(response)
            })
            .catch((error) => {
                return error
            })
    },
    createUpdateClientType: ({ commit }, item) => {
        return axios.post('/Drive/CreateUpdateClientType', item)
            .then((response) => {
                commit('setUpdateSelectList', response.data)
                return response
            }, (response) => {
                let errorText = ''
                switch (response.response.data.ErrorCode) {
                case 103:
                    errorText = 'Emnet eksisterer allerede i listen'
                    break
                default:
                    errorText = 'Noget gik galt. Prøv venligst igen'
                    break
                }
                Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
                commit('errorHandler', response)
                throw new Error(response)
            })
            .catch((error) => {
                return error
            })
    },
    createUpdateEstateType: ({ commit }, item) => {
        return axios.post('/Drive/CreateUpdateEstateType', item)
            .then((response) => {
                commit('setUpdateSelectList', response.data)
                return response
            }, (response) => {
                let errorText = ''
                switch (response.response.data.ErrorCode) {
                case 103:
                    errorText = 'Emnet eksisterer allerede i listen'
                    break
                default:
                    errorText = 'Noget gik galt. Prøv venligst igen'
                    break
                }
                Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
                commit('errorHandler', response)
                throw new Error(response)
            })
            .catch((error) => {
                return error
            })
    },
    createUpdateProblemType: ({ commit }, item) => {
        return axios.post('/Drive/CreateUpdateProblemType', item)
            .then((response) => {
                commit('setUpdateSelectList', response.data)
                return response
            }, (response) => {
                let errorText = ''
                switch (response.response.data.ErrorCode) {
                case 103:
                    errorText = 'Emnet eksisterer allerede i listen'
                    break
                default:
                    errorText = 'Noget gik galt. Prøv venligst igen'
                    break
                }
                Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
                commit('errorHandler', response)
                throw new Error(response)
            })
            .catch((error) => {
                return error
            })
    },
    createUpdateWeatherType: ({ commit }, item) => {
        return axios.post('/Drive/CreateUpdateWeatherType', item)
            .then((response) => {
                commit('setUpdateSelectList', response.data)
                return response
            }, (response) => {
                let errorText = ''
                switch (response.response.data.ErrorCode) {
                case 103:
                    errorText = 'Emnet eksisterer allerede i listen'
                    break
                default:
                    errorText = 'Noget gik galt. Prøv venligst igen'
                    break
                }
                Vue.prototype.$notify({group: 'info', type: 'warn', title: '', text: errorText})
                commit('errorHandler', response)
                throw new Error(response)
            })
            .catch((error) => {
                return error
            })
    },
    setSelectedMultipleSupplyTypeFromId: ({ commit }, supplyTypeId) => {
        commit('setSelectedMultipleSupplyType', supplyTypeId)
    },
    setNonSelectedMultipleSupplyType: ({ commit }) => {
        commit('setNonSelectedMultipleSupplyType')
    },
    setApplicationGroupList: ({ commit }, user) => {
        let promises = []
        let appObj = {
            applicationId: undefined,
            systemNameList: undefined
        }
        user.roles.forEach(role => {
            appObj = {
                applicationId: role.applicationId,
                systemNameList: role.systemNameList
            }
            if (role.filterGroupList && role.filterGroupList.length > 0) {
                appObj['filterGroupList'] = role.filterGroupList
            }
            promises.push(
                axios.post('/UserAdmin/GetApplicationGroupList', appObj).then((response) => {
                    return response.data
                }, (response) => {
                    commit('errorHandler', response)
                })
            )
        })
        return Promise.all(promises).then((response) => {
            commit('setGroupIdList', response)
            return response.data
        })
    },
    setEmployee: ({ commit }, user) => {
        commit('setEmployee', user)
        return true
    },
    setCompany: ({ commit }, company) => {
        commit('setCompany', company)
        return true
    },
    setClearUserExist: ({ commit }) => {
        commit('setClearUserExist')
    },
    setClearCompanyExist: ({ commit }) => {
        commit('setClearCompanyExist')
    },
    setUnlockUser: ({ commit }, user) => {
        let userObj = {
            userId: user.userId
        }
        return axios.post('/UserAdmin/UnlockUser', userObj).then((response) => {
            commit('setEmployeeUnlocked', user.userId)
        }, error => {
            commit('errorHandler', error)
        })
    },
    setActivateUser: ({ commit, rootState }, user) => {
        let userObj = {
            userId: user.info.userId,
            organizationId: rootState.global.selectedOrganization.id
        }
        return axios.post('/UserAdmin/ActivateUser', userObj).then((response) => {
            commit('successHandler')
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    setDeactivateUser: ({ commit, rootState }, user) => {
        let userObj = {
            userId: user.info.userId,
            organizationId: rootState.global.selectedOrganization.id
        }
        return axios.post('/UserAdmin/DeactivateUser', userObj).then((response) => {
            commit('successHandler')
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    setUserExist: ({ commit }, email) => {
        return axios.post('/UserAdmin/GetUserInfo', {email: email}).then((response) => {
            if (response.data.email) {
                commit('setUserExist', response.data)
            }
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },
    setCompanyExist: ({ commit }, email) => {
        return axios.post('/UserAdmin/GetOrganization', {email: email}).then((response) => {
            if (response.data.email) {
                commit('setCompanyExist', response.data)
            }
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    },

    setUserFacilityGroups: ({ commit }, userId) => {
        return axios.post('/Facility/GetFacilityUserGroups', { userId: userId })
            .then((response) => {
                if (response.data && response.data.userGroups) {
                    commit('setUserFacilityGroups', response.data.userGroups)
                }
                return response.data
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },
    setFacilityGroups: ({ commit }) => {
        return axios.post('/Facility/InitFacilityAdmin')
            .then((response) => {
                if (response.data.facilityUserGroups) {
                    commit('setFacilityGroups', response.data.facilityUserGroups)
                }
                return response.data
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },

    setAssociatedUsers: ({ commit }, userObject) => {
        return axios.post('/UserAdmin/GetUsersAssociatedToUser', userObject)
            .then((response) => {
                commit('setAssociatedUsers', response.data)
                return response.data
            })
            .catch((error) => {
                commit('errorHandler', error)
                throw error
            })
    },
    updateAssociatedUsers: ({ commit, rootState }, groupObject) => {
        const oldIdList = rootState.administration.associatedUserList.map(user => user.userId)
        const newIdList = groupObject.associatedUserList.map(user => user.userId)
        let promises = []
        const addUsers = groupObject.associatedUserList.filter(value => !oldIdList.includes(value.userId))
        const removeUsers = rootState.administration.associatedUserList.filter(value => !newIdList.includes(value.userId))

        if (addUsers.length > 0) {
            promises.push(axios.post('/UserAdmin/AddUsersToUser', {
                userId: groupObject.userId,
                associatedUserIdList: addUsers.map(user => user.userId),
                applicationId: groupObject.applicationId
            })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    commit('errorHandler', error)
                    throw error
                }))
        }
        if (removeUsers.length > 0) {
            promises.push(axios.post('/UserAdmin/RemoveUsersFromUser', {
                userId: groupObject.userId,
                associatedUserIdList: removeUsers.map(user => user.userId),
                applicationId: groupObject.applicationId
            })
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    commit('errorHandler', error)
                    throw error
                }))
        }

        return Promise.all(promises)
            .then((response) => {
                commit('setAssociatedUsers', groupObject.associatedUserList)
                return groupObject.associatedUserList
            })
    },
    getUserLog: ({ commit }, params) => {
        return axios.post('/UserAdmin/GetUserLog', params).then((response) => {
            return response.data
        }, error => {
            commit('errorHandler', error)
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/administration/administration.js